import styled from 'styled-components'

export const PageWrapper = styled.div`
  position: fixed;
  min-height: 100%;
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 226px;
  justify-content: center;
  right: 0;
  margin: 0;
  background: white;
`



// WEBPACK FOOTER //
// ./src/Components/Page/NotAuthorised/style.js